// import { rgba } from 'polished';
import styled from 'styled-components';
import { motion } from 'framer-motion';

// Config import
import { defaultTransition } from '@config/transition';

export const Container = styled(motion.div).attrs(defaultTransition)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  padding: 2rem 2rem 2rem 2rem;
  flex: 1;
  position: relative;
  overflow: hidden;
  overflow-y: scroll;

  @media screen and (max-width: 768px) {
    gap: 2rem;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 0.25rem;
  }
  /* Track */
  ::-webkit-scrollbar-track {
    background: none;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.background_primary};
    border-radius: 0.25rem;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  .titleRow {
    align-self: flex-start;
    display: flex;
    flex-direction: row;
    margin-bottom: 2rem;
    width: 100%;

    @media screen and (max-width: 768px) {
      margin-bottom: 0;
    }

    .title {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      @media screen and (max-width: 768px) {
        justify-content: flex-end;
      }

      button {
        margin-right: 0;
      }
    }

    button {
      margin-right: 1rem;
      color: ${({ theme }) => theme.button_high};

      svg {
        width: 1.5rem;
        height: 1.5rem;
      }
    }

    p {
      font-weight: 600;
      font-size: 1.25rem;
    }
  }

  .unavailableNotice {
    color: ${({ theme }) => theme.font_danger};
    margin-top: 1rem;
    margin-bottom: 2.5rem;
    p {
      font-size: 1rem;
      font-weight: 600;

      @media screen and (max-width: 768px) {
        text-align: center;
      }
    }
  }

  .mainDesktop {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    align-self: stretch;
    gap: 2rem;

    @media screen and (max-width: 768px) {
      flex: 1;
    }
  }

  .totalsSection {
    display: flex;
    flex-direction: column;
    align-self: flex-end;
    width: 20.5rem;
    gap: 1rem;
    margin-top: 2.5rem;
    margin-bottom: 8rem;
    flex: 1;

    @media screen and (max-width: 768px) {
      align-self: center;
      width: 100%;
      margin-top: 0;
      margin-bottom: 0;
      flex: none;
    }
    .regularRow {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .cupom {
        button {
          p {
            color: ${({ theme }) => theme.font_primary};
            font-size: 0.875rem;
            text-decoration: underline;
          }
        }
      }
      .discountValue {
        color: ${({ theme }) => theme.font_primary};
      }
    }

    .totalRow {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      p {
        font-weight: 600;
        font-size: 1.25rem;
      }
    }
  }

  @media screen and (max-width: 1800px) {
    ul {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
  }

  @media screen and (max-width: 1440px) {
    ul {
      grid-template-columns: repeat(1, minmax(0, 1fr));
    }
  }

  @media screen and (max-width: 768px) {
    padding: 1rem 1rem 1rem 1rem;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-right: 2rem;
  margin-left: 2rem;

  align-self: stretch;

  margin-top: 1rem;
  border-top: 0.188rem solid ${({ theme }) => theme.font_secondary};
  border-radius: 0.125rem;
  padding: 1rem 0;

  gap: 1rem;

  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
    margin-right: 0;
    margin-left: 0;
    margin-bottom: 1rem;
    border-top: none;
    border-radius: 0;
    padding: 0 0.5rem;
  }

  .action {
    width: 21rem;
    max-width: 100%;
  }

  .removeUnavailable {
    color: ${({ theme }) => theme.font_high};
  }
`;
